<template>
  <section id="contact" class="contact-section">
    <h2>Contact Us</h2>
    <div class="contact-info">
      <h3>Schedule an Appointment</h3>
      <div class="contact-details">
        <div class="contact-item">
          <i class="fas fa-phone"></i>
          <p>Phone: (555) 123-4567</p>
        </div>
        <div class="contact-item">
          <i class="fas fa-envelope"></i>
          <p>Email: appointments@drmayolee.com</p>
        </div>
        <div class="contact-item">
          <i class="fas fa-map-marker-alt"></i>
          <p>Address: 123 Medical Center Drive, Suite 100<br>Silicon Valley, CA 94025</p>
        </div>
        <div class="contact-item">
          <i class="fas fa-clock"></i>
          <p>Office Hours: Monday - Friday: 9:00 AM - 5:00 PM</p>
        </div>
      </div>
      <button class="cta-button" @click="requestAppointment">Request Appointment</button>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ContactSection',
  methods: {
    requestAppointment() {
      // Implement appointment request logic here
      console.log('Appointment requested')
    }
  }
}
</script>

<style scoped>
.contact-section {
  padding: 60px 20px;
  background-color: #f8f9fa;
}

.contact-info {
  max-width: 800px;
  margin: 0 auto;
  padding: 30px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.contact-details {
  margin: 30px 0;
}

.contact-item {
  display: flex;
  align-items: center;
  margin: 20px 0;
}

.contact-item i {
  font-size: 24px;
  color: #42b983;
  margin-right: 15px;
  width: 30px;
}

.cta-button {
  background-color: #42b983;
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 25px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.cta-button:hover {
  background-color: #3aa876;
}
</style>
